<div class="card">
    <div class="card-header">
        Details
    </div>
    <div class="card-body">
        <spinner [showSpinner]="isLoadingClient">
            <dl>
                <dt>Id</dt>
                <dd>{{ client.clientId || '-'}}</dd>
                <dt>Name</dt>
                <dd>{{ client.clientName || '-'}}</dd>
                <dt>Created At</dt>
                <dd>{{ (client.createdAt | date:'yyyy-MM-dd HH:mm:ss') || '-'}}</dd>
                <dt>Enabled</dt>
                <dd>{{ client.enabled || '-'}}</dd>
                <dt>Last Accessed</dt>
                <dd>{{ (client.lastAccessed | date:'yyyy-MM-dd HH:mm:ss') || '-'}}</dd>
                <dt>Access Token Type</dt>
                <dd>{{ client.accessTokenType || '-'}}</dd>
            </dl>
        </spinner>
    </div>
</div>
<div class="row">
    <div class="col-md-6">
        <div class="card">
            <div class="card-header">
                Claims
            </div>
            <div class="card-body">
                <spinner [showSpinner]="isLoadingClient">
                    <div class="table-container">
                        <div class="table-responsive">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Id</th>
                                        <th>Key</th>
                                        <th>Value</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let claim of client.clientClaims">
                                        <td>
                                            {{claim.id}}
                                        </td>
                                        <td>
                                            {{claim.key}}
                                        </td>
                                        <td>
                                            {{claim.value}}
                                        </td>
                                        <td>
                                            <button confirm confirm-message="Do you want to delete claim {{claim.key}}?"
                                                (confirm-action)="deleteClaim(claim.id)"
                                                class="btn btn-sm btn-danger">Delete</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <button class="btn btn-primary" (click)="addClientClaim()">Add claim</button>
                        </div>
                    </div>
                </spinner>
            </div>
        </div>
    </div>
    <div class="col-md-6">
        <div class="card">
            <div class="card-header">
                Allowed Scopes
            </div>
            <div class="card-body">
                <spinner [showSpinner]="isLoadingClient">
                    <div class="table-container">
                        <div class="table-responsive">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Id</th>
                                        <th>Scope</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let scope of client.allowedScopes">
                                        <td>
                                            {{scope.id}}
                                        </td>
                                        <td>
                                            {{scope.value}}
                                        </td>
                                        <td><button confirm
                                                confirm-message="Do you want do delete allowed scope '{{scope.value}}'?"
                                                (confirm-action)="deleteAllowedScope(scope.id)"
                                                class="btn btn-sm btn-danger">Delete</button></td>
                                    </tr>
                                </tbody>
                            </table>
                            <button class="btn btn-primary" (click)="addClientAllowedScope()">Add Scope</button>
                        </div>
                    </div>
                </spinner>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-md-6">
        <div class="card">
            <div class="card-header">
                Secrets
            </div>
            <div class="card-body">
                <spinner [showSpinner]="isLoadingClientSecrets">
                    <div class="table-container">
                        <div class="table-responsive">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Client Id</th>
                                        <th>Secret Id</th>
                                        <th>Description</th>
                                        <th>Expires at (UTC)</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let secret of clientSecrets">
                                        <td>
                                            {{clientId}}
                                        </td>
                                        <td>
                                            {{secret.id}}
                                        </td>
                                        <td>
                                            {{secret.description || '-'}}
                                        </td>
                                        <td>
                                            {{(secret.expiration | date:'yyyy-MM-dd HH:mm:ss') || '-'}}
                                        </td>
                                        <td><button confirm (confirm-action)="deleteSecret(clientId, secret.id)"
                                                confirm-message="Do you want to delete secret {{secret.id}}?"
                                                class="btn btn-sm btn-danger">Delete</button></td>
                                    </tr>
                                </tbody>
                            </table>
                            <button class="btn btn-primary" (click)="addSecret()">Add secret</button>
                        </div>
                    </div>
                </spinner>
            </div>
        </div>
    </div>
</div>